import { render, staticRenderFns } from "./CheckPricePage.vue?vue&type=template&id=2e115b69"
import script from "./CheckPricePage.vue?vue&type=script&lang=js"
export * from "./CheckPricePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports